export default __webpack_public_path__ + "assets/images/43a6c41f6d4cabfdc4cdfcbeff483aa1.svg";